<template>
  <b-form-group
    :label="label"
    :label-for="inputId"
    :label-class="labelClass"
  >
    <b-form-input
      :id="inputId"
      :value="value"
      class="form-control text-uppercase"
      :placeholder="placeholder"
      maxlength="18"
      autocomplete="off"
      :disabled="disabled"
      @input="onInput"
      @blur="$emit('blur', $event)"
    />
    <small
      v-if="showError"
      class="text-danger"
    >
      {{ errorMessage }}
    </small>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { applyCpfMask, applyCnpjMask } from '@/helpers/string'

export default {
  name: 'CpfCnpjInput',

  components: {
    BFormGroup,
    BFormInput,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'CPF ou CNPJ',
    },
    inputId: {
      type: String,
      default: 'cpfCnpjInput',
    },
    placeholder: {
      type: String,
      default: '00.000.000/0000-00',
    },
    labelClass: {
      type: String,
      default: 'font_size_label',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'O campo CPF ou CNPJ é inválido',
    },
    showError: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onInput(inputValue) {
      const unmaskedValue = this.somenteAlfanumericos(inputValue).toUpperCase()
      const isCnpj = /[A-Z]/.test(unmaskedValue) || unmaskedValue.length > 11
      const maskedValue = isCnpj ? applyCnpjMask(unmaskedValue) : applyCpfMask(unmaskedValue)

      this.$emit('input', maskedValue)
    },

    somenteAlfanumericos(valor) {
      return valor.replace(/[^a-zA-Z0-9]/g, '')
    },
  },
}
</script>
